import { MenuProps } from './menu-props';
import React from 'react';
import { cx } from '@mint/core';
import styled from 'styled-components';

/**
 * List root class name.
 */
const ROOT_CLASS_NAME = 'menu';

/**
 * Component to use.
 */
const DEFAULT_COMPONENT = 'ul';

/**
 * List component implementation before styling.
 */
export const MenuComponent = React.forwardRef<any, MenuProps>(
  (props, ref): React.ReactElement => {
    const {
      children,
      className,
      component: Component = DEFAULT_COMPONENT,
      dense,
      ...rest
    } = props;

    const componentProps = {
      className: cx(ROOT_CLASS_NAME, className),
      ...rest,
      ref,
    };

    return (
      <Component role="menu" {...componentProps}>
        {children}
      </Component>
    );
  },
);

MenuComponent.displayName = 'Menu';

export const Menu = styled(MenuComponent)`
  margin: 0;
  padding: ${props => props.theme.ms(-2, 'em')} 0;
`;
